// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__115fT","topBottomGutter":"Layout_topBottomGutter__DXauL"};